module.exports = __webpack_public_path__ + "img/ET411-4开打印头渲染.636.d0fef75f.png";